globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.ShowMediaLogo = (function(superClass) {

  utils.extend(ShowMediaLogo, superClass);

  function ShowMediaLogo() {
    return ShowMediaLogo.__super__.constructor.apply(this, arguments);
  }

  $.extend(ShowMediaLogo.prototype, {
    init: function() {
      return ShowMediaLogo.__super__.init.apply(this, arguments);
    },
  });

  return ShowMediaLogo;

})(appCustomerSpace.Modal);
